import AxiosPermisos from "@/services/axiosPermisos";

import { paths } from "./path";
import { map_query } from "@/core/functions/map-path-query";

async function getLicense(id = 0) {
  return await AxiosPermisos.get(paths.show.concat(`/${id}`), true, "v2");
}

async function getTraceability(id = 0, data = {}) {
  return await AxiosPermisos.get(
    paths.licenses_by_business_partner
      .concat(`/${id}/traceability`)
      .concat(map_query(data)),
    true,
    "v2"
  );
}

// Retraction
const postRetractionService = async (id = 0, data = {}) => {
  await AxiosPermisos.post(
    paths.licenses_by_business_partner.concat(`/${id}/retraction`),
    true,
    data,
    "v2"
  );
};

async function saveReverseRetraction(license_id, data) {
  return await AxiosPermisos.post(
    `${paths.reverseRetraction}/${license_id}/reverse-retraction`,
    true,
    data,
    "v2"
  );
}
export { getLicense, getTraceability, postRetractionService, saveReverseRetraction };
